import { Component, Input } from '@angular/core';
import { RRLayoutsModel } from '../../../layout-builder/models/layouts.model';
import { RRFooterModel } from '../../models/footer.model';

@Component({
  selector: 'rr-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() model: RRFooterModel;
  @Input() layout: RRLayoutsModel[];
  @Input() footerClass: string;

  constructor() {}
}
